import React, {memo} from 'react';
import { imgUrl } from '../../utils/url';

const ErrorDisplay = props =>{
    return (
        <div className="emptyDataMessage" data-testid="emptyDataMessage">
            <img src={imgUrl('/images/okr-empty.png')} />
            <p>{props.errorText}</p>
        </div>
    );
}

export default memo(ErrorDisplay);